import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import Form from 'component/utils/Form'
import Input from 'component/utils/Input'
import MagnifierAlt from 'images/magnifier-alt.svg'
import ClearSVG from 'component/svgComponents/clear'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import Select from '../../components/Select/Select'

const FIELDS = ['dsMission']

const FilterForm = ({ fields, submit, translate, user, handleBranchChange, branchs, handleTextChange, handleParameterSearchChange, selectedOptions, onChange }) => {
  const [text,setText] = useState("")
  const [withValueEffect, setWithValueEffect] = useState("")
  const [enterMode, setEnterMode] = useState(false)
  const beforeSubmit = (event) => {
    event.preventDefault()
    if(text !== "") setEnterMode(true)
    else setEnterMode(false)
    submit(text.replace(/\s+/g, ' ').trim(), true)
  }


  useEffect(() => {
    if(enterMode) setWithValueEffect("search-value-effect")
    else setWithValueEffect("")
  }, [enterMode])

  const handleInputChange = (e, setText, onChange) => {
    const {value} = e.target;

    setText(value);
    handleTextChange(value)
    onChange(value)
  };

  const onClearInput = () => {
    if(!text) return
    setText("")
    handleTextChange("")
    onChange("")
    setEnterMode(false)
    submit(null, true)
  }

  return (
    <form onSubmit={beforeSubmit}  className='system-parameters-form'>
      
      <Col className={`system-parameters-search ${withValueEffect}`} >
        <Field {...fields.text} ignoreActiveClass>
          <Input
            value={text}
            onChange={(e) => handleInputChange(e, setText, onChange)}
            className='system-parameters-search-input'
            placeholder={"Pesquisar por descrição, parâmetro ou valor"}
          />
        </Field>
        
        <button style={{ background: 'none', border: 'none' }}>
          <img src={MagnifierAlt} className='system-parameters-search-magnifier' alt="" />
        </button>

        {text.length > 0 && <ClearSVG className="system-parameters-search-clear" onClick={onClearInput} />}
      </Col>

      <div style={{ marginLeft: '12px'}}>
        { <Select
            placeholder={"Selecione um ou mais tipos de pesquisa"}
            fill
            required
            isMulti
            options={[
              { value: 'descricao', label: 'Descrição' },
              { value: 'parametro', label: 'Parâmetro' },
              { value: 'valor', label: 'Valor' },
            ]}
            groupOptions
            onChange={handleParameterSearchChange}
            value={selectedOptions}
           
        />}
      </div>

      <div>
        {<RegionBranchMultipleSelect
            onChange={handleBranchChange}
            placeholder={translate("field.selectMultiStores")}
            name={'branchs'}
            translate={translate}
            user={user}
            value={branchs}
            required
          />}
      </div>
    </form>
  )
}

FilterForm.propTypes = {
  fields: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleBranchChange: PropTypes.func.isRequired,
  branchs: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  handleParameterSearchChange: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  handleTextChange:  PropTypes.func.isRequired
}

export default Form({ fields: FIELDS })(FilterForm)

export { FilterForm }
